import { useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Container,
  Grid,
  Card,
  CardContent,
  TextField,
  FormGroup,
  FormLabel,
  LinearProgress,
  Typography,
  Tab,
  AppBar,
} from "@material-ui/core";

import { TabContext, TabList } from "@material-ui/lab";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import HeaderClientes from "components/_refactor/headers/clients";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import FilterCard from "components/_refactor/filter-card";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import useLogs from "hooks/logs";

import { IsMobile, IsMobile500, IsMobile900 } from "utils/is-mobile";
import Clients from "./views/clients";
import ShoppingHistory from "./views/shopping-history";
import ContactHistory from "./views/contact-history";
import SalesInformation from "./views/sales-information";
import Reminders from "./views/reminder";
import DesireProducts from "./views/desire-products";

const useCustomStyles = makeStyles({
  option: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    wordBreak: "keep-all",
  },
  paper: {
    width: "max-content !important",
    minWidth: "100%",
  },
  popper: {
    maxWidth: "calc(100% - 60px - 1.5rem)",
    width: "max-content",
  },
});

export default function Consumidor360() {
  const snackbar = useSnackbar();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();
  const isMobile500 = IsMobile500();

  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 4;

  const [cpf, setCpf] = useState("");
  const [seller, setSeller] = useState("");
  const [validateButton, setValidateButton] = useState(false);
  const [searchingSeller, setSearchingSeller] = useState(false);
  const [sellerList, setSellerList] = useState([]);
  const [customerDetail, setCustomerDetail] = useState([]);
  const [customerInfo, setCustomerInfo] = useState([]);
  const [customerCharacteristics, setCustomerCharacteristics] = useState([]);
  const [salesHistoric, setSalesHistoric] = useState([]);
  const [contactHistoric, setContactHistoric] = useState([]);
  const [reminders, setReminders] = useState([]);
  const [desireProduct, setDesireProduct] = useState([]);

  const [storeList, setStoreList] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [searchingStore, setSearchingStore] = useState(false);

  const [clearFilters, setClearFilters] = useState(false);
  const [searchingClientData, setSearchingClientData] = useState(false);
  const [searchingProductDesire, setSearchingProductDesire] = useState(false);
  const [searchingReminders, setSearchingReminders] = useState(false);
  const [searchingContactHistoric, setSearchingContactHistoric] =
    useState(false);

  const [hasUpdatedDesireProduct, setHasUpdatedDesireProduct] = useState(false);
  const [hasUpdatedReminders, setHasUpdatedReminders] = useState(false);
  const [showMessageError, setShowMessageError] = useState(false);

  const [valueTab, setValueTab] = useState("1");

  const handleGetStoreList = async () => {
    setSearchingStore(true);

    try {
      const res = await Api.get(
        "store",
        "commercialstructure",
        "?idMarca=TODAS",
        true
      );
      if (res?.Success) {
        setStoreList(res?.Result);
      }
    } catch (error) {
      console.log(error);
      setLocalStorageApiProblem({
        idMenuAccess: "156",
        screen: "	Consumidor 360",
        problem: `Erro na chamada do endpoint store - ${error}`,
      });
    } finally {
      setSearchingStore(false);
    }
  };

  const handleGetSelletList = async () => {
    if (!clearFilters) {
      setSearchingSeller(true);
    }

    try {
      const resp = await Api.get(
        "seller-list",
        "action",
        `?IdPessoaLoja=${selectedStore?.Id?.toString()}`,
        true
      );
      if (resp?.Success) {
        if (resp?.Result?.ListaVendedores?.length === 0) {
          snackbar.showMessage(
            "Nenhum vendedor localizado. Faça a busca novamente",
            {
              severity: "success",
            }
          );
        } else {
          setSellerList(resp?.Result?.ListaVendedores);
        }
      }
    } catch (error) {
      console.log(error);
      snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "156",
        screen: "	Consumidor 360",
        problem: `Erro na chamada do endpoint seller-list - ${error}`,
      });
    } finally {
      setSearchingSeller(false);
    }
  };

  const handleGetClientData = async () => {
    setSearchingClientData(true);
    setCustomerDetail([]);
    setCustomerInfo([]);
    setCustomerCharacteristics([]);
    setSalesHistoric([]);
    setShowMessageError(false);

    try {
      const resp = await Api.get(
        "customer-detail",
        "action",
        `?Cpf=${cpf?.replace(
          /\D/g,
          ""
        )}&IdPessoaLoja=${selectedStore?.Id?.toString()}`,
        true
      );
      if (resp?.Success) {
        setCustomerDetail(resp?.Result?.Agenda?.Cliente || []);
        setCustomerInfo(resp?.Result?.Agenda?.Dicas || []);
        setCustomerCharacteristics(
          resp?.Result?.Agenda?.Cliente?.Caracteristica?.Valor || ""
        );
        setSalesHistoric(resp?.Result?.Vendas || []);
      } else if (resp?.errorType) {
        setShowMessageError(true);
      }
    } catch (error) {
      console.log(error);
      snackbar.showMessage(error, {
        severity: "error",
      });
      setShowMessageError(true);
      setLocalStorageApiProblem({
        idMenuAccess: "156",
        screen: "	Consumidor 360",
        problem: `Erro na chamada do endpoint customer-detail - ${error}`,
      });
    } finally {
      setSearchingClientData(false);
    }
  };

  const handleGetProductDesire = async () => {
    setSearchingProductDesire(true);
    setHasUpdatedDesireProduct(false);
    setDesireProduct([]);

    try {
      const resp = await Api.get(
        "product-base-desire-list",
        "action",
        `?Cpf=${cpf?.replace(
          /\D/g,
          ""
        )}&IdPessoaLoja=${selectedStore?.Id?.toString()}`,
        true
      );
      if (resp?.Success) {
        setDesireProduct(resp?.Result || []);
      }
    } catch (error) {
      console.log(error);
      snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "156",
        screen: "	Consumidor 360",
        problem: `Erro na chamada do endpoint product-base-desire-list - ${error}`,
      });
    } finally {
      setSearchingProductDesire(false);
    }
  };

  const handleGetReminders = async () => {
    setSearchingReminders(true);
    setHasUpdatedReminders(false);
    setReminders([]);

    try {
      const resp = await Api.get(
        "user-storage-reminders-list",
        "action",
        `?Cpf=${cpf?.replace(
          /\D/g,
          ""
        )}&IdPessoaLoja=${selectedStore?.Id?.toString()}`,
        true
      );
      if (resp?.Success) {
        setReminders(resp?.Result || []);
      }
    } catch (error) {
      console.log(error);
      snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "156",
        screen: "	Consumidor 360",
        problem: `Erro na chamada do endpoint user-storage-reminders-list - ${error}`,
      });
    } finally {
      setSearchingReminders(false);
    }
  };

  const handleGetContactHistoric = async () => {
    setSearchingContactHistoric(true);
    setContactHistoric([]);

    try {
      const resp = await Api.get(
        "customer-contact-histoy",
        "action",
        `?Cpf=${cpf?.replace(
          /\D/g,
          ""
        )}&IdPessoaLoja=${selectedStore?.Id?.toString()}`,
        true
      );
      if (resp?.Success && resp?.Result?.length !== 0) {
        let newObject = {};
        const newEmailList = [];

        resp?.Result?.map((item) => {
          newObject = {
            date: item.DataHoraFormat,
            store: item.NomeLoja,
            seller: item.NomeVendedor,
            contactMode: item.ModoContato,
            thermometer: item.Termometro,
            schedule: item.NomeAgenda,
            characteristic: item.CaracteristicaCliente,
            observations: item.Observacao,
            status: item.StatusContato,
            id: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
          };
          newEmailList.push(newObject);
        });
        setContactHistoric(newEmailList);
      }
    } catch (error) {
      console.log(error);
      snackbar.showMessage(error, {
        severity: "error",
      });
      setLocalStorageApiProblem({
        idMenuAccess: "156",
        screen: "	Consumidor 360",
        problem: `Erro na chamada do endpoint customer-contact-histoy - ${error}`,
      });
    } finally {
      setSearchingContactHistoric(false);
    }
  };

  const handleGetInformations = () => {
    setLocalStorageActions({
      nomeTela: "Consumidor 360",
      idMenu: "156",
      acao: "Clicou para Pesquisar",
    });
    handleGetClientData();
    handleGetProductDesire();
    handleGetReminders();
    handleGetContactHistoric();
  };

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setSelectedStore(null);
    setCpf("");
    setSeller("");
    setReminders([]);
    setSellerList([]);
    setCustomerInfo([]);
    setDesireProduct([]);
    setSalesHistoric([]);
    setCustomerDetail([]);
    setContactHistoric([]);
    setCustomerCharacteristics([]);

    setTimeout(() => {
      setClearFilters(false);
    }, 400);
  };

  useEffect(() => {
    if (
      searchingReminders ||
      searchingClientData ||
      searchingProductDesire ||
      searchingContactHistoric ||
      seller === "" ||
      cpf === "" ||
      cpf?.length !== 14 ||
      !selectedStore
    ) {
      setValidateButton(true);
    } else {
      setValidateButton(false);
    }
  }, [
    cpf,
    selectedStore,
    searchingReminders,
    searchingClientData,
    searchingProductDesire,
    searchingContactHistoric,
    seller,
  ]);

  useEffect(() => {
    if (selectedStore) {
      handleGetSelletList();
    }
  }, [selectedStore]);

  useEffect(() => {
    if (hasUpdatedDesireProduct) {
      handleGetProductDesire();
    }
  }, [hasUpdatedDesireProduct]);

  useEffect(() => {
    if (hasUpdatedReminders) {
      handleGetReminders();
    }
  }, [hasUpdatedReminders]);

  useEffect(() => {
    if (showMessageError) {
      setTimeout(() => {
        setShowMessageError(false);
      }, 2000);
    }
  }, [showMessageError]);

  useEffect(() => {
    handleGetStoreList();
  }, []);

  const renderLoadingState = (message) => (
    <div style={{ marginTop: "1.5rem", marginBottom: "-1rem" }}>
      <span>{message}</span>
      <LinearProgress />
    </div>
  );

  return (
    <>
      <HeaderClientes section="Consumidor 360°" subsection="Clientes" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleGetInformations}
          disabled={validateButton}
          searching={
            searchingReminders ||
            searchingClientData ||
            searchingProductDesire ||
            searchingContactHistoric
          }
          handleClearFilters={handleClearFilters}
          bottonInfo={
            <>
              {(searchingReminders ||
                searchingClientData ||
                searchingProductDesire ||
                searchingContactHistoric) &&
                renderLoadingState("Buscando dados do consumidor...")}
              {searchingSeller &&
                selectedStore &&
                !clearFilters &&
                renderLoadingState("Buscando lista de vendedores...")}
            </>
          }
        >
          <Grid item xs={itemXS}>
            <AutoCompleteField
              options={storeList}
              label="Lojas"
              onChange={setSelectedStore}
              value={selectedStore}
              disabled={
                searchingClientData ||
                searchingProductDesire ||
                searchingContactHistoric ||
                storeList?.length === 0
              }
              loading={searchingStore || clearFilters}
              customTooltipText={(option) => option.Apelido}
              required
            />
          </Grid>
          <Grid item xs={itemXS}>
            <AutoCompleteField
              options={sellerList}
              label="Vendedores"
              onChange={setSeller}
              value={seller}
              disabled={
                searchingReminders ||
                searchingClientData ||
                searchingProductDesire ||
                searchingContactHistoric ||
                !selectedStore ||
                sellerList?.length === 0
              }
              optionIdKey="IdLojaVendedor"
              loading={searchingStore || clearFilters}
              required
            />
          </Grid>
          <Grid item xs={itemXS}>
            <FormGroup>
              <FormLabel>CPF Consumidor *</FormLabel>
              <TextField
                fullWidth
                name="cpf"
                type="text"
                value={cpf}
                variant="outlined"
                disabled={
                  searchingReminders ||
                  searchingClientData ||
                  searchingProductDesire ||
                  searchingContactHistoric ||
                  !seller
                }
                placeholder="000.000.000-00"
                onChange={(e) => {
                  setCpf(MaskAndValid.maskCPF(e.target.value));
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 14);
                }}
              />
            </FormGroup>
          </Grid>
        </FilterCard>

        {(!searchingReminders ||
          !searchingClientData ||
          !searchingProductDesire ||
          !searchingContactHistoric) &&
          customerDetail?.length !== 0 &&
          customerDetail && (
            <Grid container style={{ marginBottom: "1rem" }}>
              <Grid item xs={12}>
                <TabContext value={valueTab}>
                  <AppBar position="static" color="transparent">
                    <TabList
                      style={{ backgroundColor: "RGBA(255, 193, 197, 0.2)" }}
                      onChange={handleChangeTab}
                      centered
                      variant={isMobile900 ? "scrollable" : ""}
                      scrollButtons="on"
                      aria-label="scrollable auto tabs example"
                    >
                      <Tab
                        style={{ maxWidth: "max-content" }}
                        label="Informações do Cliente"
                        value="1"
                      />
                      <Tab
                        style={{ maxWidth: "max-content" }}
                        hidden={salesHistoric?.length === 0}
                        label="Histórico de Compras"
                        value="2"
                      />
                      <Tab
                        style={{ maxWidth: "max-content" }}
                        hidden={contactHistoric?.length === 0}
                        label="Histórico de Contatos"
                        value="3"
                      />
                      <Tab
                        style={{ maxWidth: "max-content" }}
                        label="Informações de Venda"
                        value="4"
                      />
                      <Tab
                        style={{ maxWidth: "max-content" }}
                        label="Lembretes"
                        value="5"
                      />
                      <Tab
                        style={{ maxWidth: "max-content" }}
                        hidden={desireProduct?.length === 0}
                        label="Produtos de Desejo"
                        value="6"
                      />
                    </TabList>
                  </AppBar>
                </TabContext>
              </Grid>
            </Grid>
          )}

        {showMessageError && (
          <Card>
            <CardContent>
              <Grid container alignItems="center">
                <Typography
                  variant="h4"
                  component="h4"
                  style={{ color: "grey" }}
                >
                  Não foram localizadas informações. Faça a busca novamente.
                </Typography>
              </Grid>
            </CardContent>
          </Card>
        )}

        {valueTab === "1" && customerDetail?.length !== 0 && customerDetail && (
          <Clients
            idVendedor={seller}
            idLoja={selectedStore?.Id}
            isMobile500={isMobile500}
            isMobile={isMobile}
            customerInfo={customerInfo}
            customerDetail={customerDetail}
            customerCharacteristics={customerCharacteristics}
            setCustomerCharacteristics={setCustomerCharacteristics}
          />
        )}
        {valueTab === "2" && salesHistoric?.length !== 0 && (
          <ShoppingHistory
            isMobile500={isMobile500}
            salesHistoric={salesHistoric}
          />
        )}
        {valueTab === "3" && contactHistoric?.length !== 0 && (
          <ContactHistory
            isMobile500={isMobile500}
            contactHistoric={contactHistoric}
          />
        )}
        {valueTab === "4" && (
          <SalesInformation
            cpf={cpf}
            idVendedor={seller?.IdLojaVendedor}
            isMobile={isMobile}
            idLoja={selectedStore?.Id}
          />
        )}
        {valueTab === "5" && (
          <Reminders
            cpf={cpf}
            reminders={reminders}
            setHasUpdatedReminders={setHasUpdatedReminders}
            isMobile500={isMobile500}
            idLoja={selectedStore?.Id}
            customerDetail={customerDetail}
            idVendedor={seller?.IdLojaVendedor}
          />
        )}
        {valueTab === "6" && (
          <DesireProducts
            cpf={cpf}
            setHasUpdatedDesireProduct={setHasUpdatedDesireProduct}
            desireProduct={desireProduct}
            isMobile500={isMobile500}
            isMobile={isMobile}
            idLoja={selectedStore?.Id}
            customerDetail={customerDetail}
            idVendedor={seller?.IdLojaVendedorAction}
          />
        )}
      </Container>
    </>
  );
}
